// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bes_a bhn_bk bhn_bl bhn_bo","SwipeLeftToClose--animating":"bes_b"};